/**
 * Newsletter Section — Form validation and feedback
 */

/**
 * Initialize newsletter form with email validation.
 */
function initNewsletterForm() {
  var form = document.querySelector('.newsletter-section__form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var email = input.value.trim();

    var errorEl = form.querySelector('#newsletter-error');

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      input.setAttribute('aria-invalid', 'true');
      input.style.outline = '2px solid red';
      if (errorEl) errorEl.textContent = 'Please enter a valid email address.';
      input.focus();
      return;
    }

    input.setAttribute('aria-invalid', 'false');
    input.style.outline = '';
    if (errorEl) errorEl.textContent = '';

    var submitBtn = form.querySelector('.newsletter-section__submit');
    var originalText = submitBtn.textContent;
    submitBtn.textContent = 'Subscribed!';
    submitBtn.disabled = true;
    input.value = '';

    setTimeout(function () {
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }, 2500);
  });
}
